import styled from 'styled-components';

import { respondDown } from 'styles/mixins';
import { Breakpoints } from 'styles/style-constants';

export const Wrapper = styled.div`
    width: 100%;
    padding-top: 6.3rem;

    ${respondDown(Breakpoints.sm)`
        padding-top: 1.6rem;
    `}
`;
